import { defineMessages } from 'react-intl-next';

export default defineMessages({
	managePortalGroupsLabel: {
		defaultMessage: 'Manage portal groups',
		description: 'Button text to Navigate user to Manage Portal Groups in JSM',
		id: 'help-center.app.common.customize-portal-buttons.manage-portal-groups-label',
	},
	editRequestTypeLabel: {
		defaultMessage: 'Edit request type',
		description: 'Button text to Navigate user to Request Type editor in JSM',
		id: 'help-center.app.common.customize-portal-buttons.edit-request-type-label',
	},
});
